import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Fa from 'react-fontawesome';
import { Modal, Button } from 'react-bootstrap';
import { getResetingTableId } from './reducer';
import { requestResetColumns } from './actions';
import {
  resetTablePreference,
} from '../../modules/App/AppActions';

class ResetColumnsModal extends Component {
  constructor() {
    super();
    this.state = {
      disabled: false,
    };
    this.cancel = this.cancel.bind(this);
    this.confirmReset = this.confirmReset.bind(this);
  }

  cancel() {
    if (!this.state.disabled) {
      this.props.dispatch(requestResetColumns(null));
    }
  }

  confirmReset() {
    if (!this.state.disabled) {
      const { tableId } = this.props;
      this.setState({ disabled: true });
      this.props.dispatch(resetTablePreference(tableId))
        .then(
          () => {
            this.setState({ disabled: false });
            this.cancel();
          },
          () => {
            this.setState({ disabled: false });
          },
        );
    }
  }

  render() {
    const { tableId, isRow } = this.props;
    const showing = tableId !== null;
    const { disabled } = this.state;
    const label = isRow ? 'rows' : 'columns';

    return (
      <Modal
        show={showing}
        onHide={this.cancel}
        bsSize="sm"
      >
        <Modal.Header closeButton>
          Reseting {label}
        </Modal.Header>
        <Modal.Body>
          {tableId !== null &&
            <div className="well well-sm">
              <p>Are you sure you want reset all the {label}?</p>
              <p>This cannot be undone.</p>
            </div>
          }
        </Modal.Body>
        <Modal.Footer>
          <div className="clearfix">
            <Button
              bsStyle="link"
              disabled={disabled}
              className="pull-left"
              onClick={this.cancel}
            >
              Cancel
            </Button>
            <Button
              bsStyle="danger"
              disabled={disabled}
              className="pull-right"
              onClick={this.confirmReset}
            >
              <Fa name={disabled ? 'spinner' : 'trash'} spin={disabled} /> Reset All {label}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}


ResetColumnsModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  tableId: PropTypes.string,
  isRow: PropTypes.bool,
};
ResetColumnsModal.defaultProps = {
  tableId: null,
  isRow: false,
};
function mapStateToProps(state) {
  return {
    tableId: getResetingTableId(state),
  };
}
export default connect(mapStateToProps)(ResetColumnsModal);
